;(function() {
    var


    //
    //init
    //
    init = function() {
        if ($('.layout-edit-profile').length > 0) {
            setupRequired();
        }
    },

    //
    // Add * to beginning of required field captions
    //
    setupRequired = function() {
        $('.required').each(function() {
            $(this).html("* " + $(this).html());
        });
    };


    //call init
    $(document).ready(init);

})();